var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { ObjectTyped } from '@timeflies/common';
import { Loader } from 'pixi.js';
import React from 'react';
import { AssetsContext } from './assets-context';
import { createLoader, createResourceName, mapStringUtil } from './create-loader';
var resourcesToAssetsMap = function (loader, loaderMap) {
    return {
        spritesheets: ObjectTyped.entries(loaderMap.spritesheets).reduce(function (acc, _a) {
            var name = _a[0];
            var resourceName = createResourceName('spritesheets', name);
            var resource = loader.resources[resourceName];
            if (resource) {
                var imageResource = loader.resources[resourceName + '_image'];
                var spritesheetUrl = imageResource.url;
                var spritesheet = resource.spritesheet;
                acc[name] = {
                    resource: resource,
                    spritesheet: spritesheet,
                    spritesheetUrl: spritesheetUrl
                };
            }
            return acc;
        }, {}),
        maps: ObjectTyped.entries(loaderMap.maps).reduce(function (acc, _a) {
            var mapName = _a[0];
            var resourceName = createResourceName('maps', mapName);
            var resource = loader.resources[resourceName];
            if (resource) {
                var images = Object.entries(loader.resources)
                    .filter(function (_a) {
                    var name = _a[0];
                    return mapStringUtil.isMapImage(name, resourceName);
                })
                    .reduce(function (acc, _a) {
                    var name = _a[0], resource = _a[1];
                    var imageName = mapStringUtil.extractMapImageName(name, resourceName);
                    acc[imageName] = resource.url;
                    return acc;
                }, {});
                acc[mapName] = {
                    schema: resource.data,
                    images: images
                };
            }
            return acc;
        }, {})
    };
};
export var AssetsLoader = function (_a) {
    var spritesheets = _a.spritesheets, maps = _a.maps, children = _a.children;
    var generateAssetsMap = React.useCallback(function (loader) {
        if (loader === void 0) { loader = Loader.shared; }
        return resourcesToAssetsMap(loader, { spritesheets: spritesheets, maps: maps });
    }, [spritesheets, maps]);
    var _b = React.useState(generateAssetsMap), assetsMap = _b[0], setAssetsMap = _b[1];
    var currentLoaderRef = React.useRef();
    React.useEffect(function () {
        var _a;
        (_a = currentLoaderRef.current) === null || _a === void 0 ? void 0 : _a.reset();
        var loader = createLoader();
        currentLoaderRef.current = loader;
        var getResourcesInfos = function (category, map) { return ObjectTyped.entries(map)
            .map(function (_a) {
            var name = _a[0], url = _a[1];
            return ([createResourceName(category, name), url]);
        }); };
        var resourcesToLoad = __spreadArray(__spreadArray([], getResourcesInfos('spritesheets', spritesheets)), getResourcesInfos('maps', maps));
        // .filter(([ resourceName ]) => !loader.resources[ resourceName ]);
        if (resourcesToLoad.length) {
            resourcesToLoad.forEach(function (_a) {
                var resourceName = _a[0], url = _a[1];
                loader.add({ name: resourceName, url: url });
            });
            loader.load(function () {
                if (currentLoaderRef.current !== loader) {
                    return;
                }
                setAssetsMap(generateAssetsMap(loader));
            });
        }
    }, [spritesheets, maps, generateAssetsMap]);
    return (React.createElement(AssetsContext.Provider, { value: assetsMap }, children));
};
